import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject, _templateObject2;

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { whiteSmoke, steel, mineShaft } from '../../styles/colors';
import { Content as AccordionContent } from '../Accordion/AccordionContent';
var SupportingText = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 0.875rem;\n  line-height: 1.25;\n  margin-left: auto;\n  margin-top: 4px;\n  white-space: normal; /* Needed to override Option style */\n"])), steel);
export var ListItemStyle = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  flex-shrink: 0;\n  font-size: 1rem;\n  min-height: 48px;\n  padding: 12px 16px;\n  ", "\n  text-align: left;\n  white-space: nowrap;\n  position: relative;\n  text-decoration: none;\n\n  ", ";\n\n  ", ";\n\n  :not(button):not([role='option']) {\n    line-height: 1.5; /* Needed to fix discrepancies in the various resets used across our frontends */\n  }\n\n  ", " > & {\n    padding-left: ", ";\n    width: 100%;\n\n    > svg {\n      ", "\n    }\n  }\n\n  &[role='menuitem'],\n  &[data-menu-group-trigger] {\n    font-size: 0.875rem;\n    padding: 12px 1.5rem;\n    ", "\n\n    * {\n      pointer-events: none;\n    }\n\n    ", " {\n      font-size: 0.75rem;\n      margin-top: 2px;\n    }\n\n    > svg {\n      left: 1.5rem;\n    }\n\n    ", " > & {\n      padding-left: ", ";\n      width: 100%;\n\n      > svg {\n        ", "\n      }\n    }\n  }\n\n  :hover,\n  :focus {\n    background: ", ";\n    outline: none;\n  }\n\n  :visited {\n    color: ", ";\n  }\n\n  /* Selected option styles are contained in SelectListbox */\n\n  ", "\n\n  > svg {\n    position: absolute;\n    left: 1rem;\n    top: 0;\n    bottom: 0;\n    margin: auto 0;\n  }\n\n  [data-keyboard-modality='false'] & {\n    :focus {\n      background: transparent;\n    }\n    :hover {\n      background: ", ";\n    }\n  }\n\n  [data-keyboard-modality='true'] & {\n    :hover {\n      background: transparent;\n    }\n    :focus {\n      background: ", ";\n    }\n  }\n\n  :disabled {\n    opacity: 0.4;\n\n    :hover,\n    :focus {\n      background: transparent;\n    }\n  }\n\n  ", "\n"])), mineShaft, function (props) {
  return props.hasIcon && 'padding-left: calc(2rem + 20px);';
}, function (_ref) {
  var onClick = _ref.onClick;
  return onClick && 'cursor: pointer';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && 'cursor: auto';
}, AccordionContent, function (props) {
  return props.hasIcon ? 'calc(3rem + 20px)' : '2rem';
}, function (props) {
  return props.hasIcon && 'left: 2rem;';
}, function (props) {
  return props.hasIcon && 'padding-left: calc(2.5rem + 20px);';
}, SupportingText, AccordionContent, function (props) {
  return props.hasIcon ? 'calc(3.5rem + 20px)' : '2.5rem';
}, function (props) {
  return props.hasIcon && 'left: 2.5rem;';
}, whiteSmoke, mineShaft, function (props) {
  return props.singleLine && "\n      align-items: baseline;\n      display: flex;\n      flex-wrap: nowrap;\n\n      ".concat(SupportingText, " {\n        padding-left: 1rem;\n        margin-top: 0;\n      }\n    ");
}, whiteSmoke, whiteSmoke, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && "opacity: 0.4;\n\n    :hover,\n    :focus {\n      background: transparent;\n    }";
});

function ListItem(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded);

  var _useMemo = useMemo(function () {
    return React.Children.toArray(children).reduce(function (acc, child) {
      if (child.type && child.type.isIcon) {
        acc.icon = child;
      } else if (child.type === SupportingText) {
        acc.supportingText = child;
      } else {
        acc.content.push(child);
      }

      return acc;
    }, {
      icon: null,
      supportingText: null,
      content: []
    });
  }, [children]),
      icon = _useMemo.icon,
      supportingText = _useMemo.supportingText,
      content = _useMemo.content;

  return /*#__PURE__*/React.createElement(ListItemStyle, _extends({}, props, {
    hasIcon: !!icon
  }), icon, content, supportingText);
}

ListItem.propTypes = {
  singleLine: PropTypes.bool,
  children: PropTypes.node.isRequired
};
ListItem.defaultProps = {
  singleLine: false
};
SupportingText.propTypes = {
  children: PropTypes.node.isRequired
};
ListItem.SupportingText = SupportingText;
export default ListItem;